import { render, staticRenderFns } from "./PaymentFinishedCard.vue?vue&type=template&id=86a47a24"
import script from "./PaymentFinishedCard.vue?vue&type=script&lang=js"
export * from "./PaymentFinishedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports